import { mask, Struct } from "superstruct";

import { registerParser } from "./index.js";

declare module "./index.js" {
    interface ParserTypes<TData> {
        superstruct: Struct<TData, unknown>;
    }
}

registerParser((parser) => {
    if (parser instanceof Struct) {
        return (input) => mask(input, parser);
    }
});
